<!-- footer-area -->
<footer>
    <div class="footer-area-two footer-bg-two" style="background-image : url(../../../assets/img/h2_footer_bg.jpg);">
        <div class="footer-top-two">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-7">
                        <div class="footer-widget">
                            <div class="fw-logo">
                                <a href="index.html"><img src="../../assets/img/skillTestLogo-transparent.png"
                                        alt=""></a>
                            </div>
                            <div class="footer-content">
                                <p>MySkillTest :: Empowering individuals and organizations through innovative skill
                                    testing,
                                    unlocking potential in today's competitive landscape.</p>
                                <div class="footer-info">
                                    <ul class="list-wrap">
                                        <li class="header-contact-two">
                                            <div class="icon">
                                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                            </div>
                                            <div class="content">
                                                <a href="mailto:info@myskilltest.com"
                                                    style="text-decoration: underline;">info@myskilltest.com</a>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="far fa-clock"></i>
                                            </div>
                                            <div class="content">
                                                <p>Mon – Sat: 8 am – 5 pm, <br> Sunday: <span>CLOSED</span></p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-5 col-sm-6">
                        <div class="footer-widget">
                            <h4 class="fw-title">Menu</h4>
                            <div class="footer-link">
                                <ul class="list-wrap">
                                    <li><a href="about.html">Company</a></li>
                                    <li><a href="contact.html">Careers</a></li>
                                    <li><a href="contact.html">Press media</a></li>
                                    <li><a href="blog.html">Our Blog</a></li>
                                    <li><a href="contact.html">Privacy Policy</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-5 col-sm-6">
                        <div class="footer-widget">
                            <h4 class="fw-title">Quick Links</h4>
                            <div class="footer-link">
                                <ul class="list-wrap">
                                    <li><a href="contact.html">How it’s Work</a></li>
                                    <li><a href="contact.html">Partners</a></li>
                                    <li><a href="contact.html">Testimonials</a></li>
                                    <li><a href="contact.html">Case Studies</a></li>
                                    <li><a href="contact.html">Pricing</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-7">
                        <div class="footer-widget">
                            <h4 class="fw-title">Our Newsletter</h4>
                            <div class="footer-newsletter">
                                <p>Sign up to MySkillTest's weekly newsletter to get the latest updates.</p>
                                <div action="#">
                                    <input type="email" placeholder="Enter your e-mail">
                                    <button type="submit">Subscribe</button>
                                </div>
                                <div class="footer-social footer-social-two">
                                    <ul class="list-wrap">
                                        <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                        <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                        <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                        <li><a href="#"><i class="fab fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom-two">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="copyright-text-two text-center">
                            <p>Copyright © Antern Technologies Pvt Ltd | All Right Reserved</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- footer-area-end -->